import React,{useContext} from "react";
import { ThemeContext } from '../provider/AppProvider';
interface UseCallBackTestProps {
    parentCallBack: ()=>void,
    childCallback:()=>void
}
export function UseCallBackTest(props: UseCallBackTestProps){
    
    const theme = useContext(ThemeContext)
    console.log(`UseCallBackTest run,theme:${JSON.stringify(theme)}`);
    return <div>
        UserCallBackTest组件:<br/>
        <button onClick={props.parentCallBack}>parentCallBack</button>
        <button onClick={props.childCallback}>childCallback</button>
    </div>
}